var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsNotifyMeWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27945",
    "data-name": "Group 27945",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.476,
    height: 24.381,
    viewBox: "0 0 30.476 24.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16660",
    "data-name": "Path 16660",
    d: "M18,11v3.048h6.1V11Z",
    transform: "translate(6.381 -0.333)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16661",
    "data-name": "Path 16661",
    d: "M16,18.453c1.463,1.082,3.368,2.514,4.876,3.642.61-.808,1.219-1.63,1.829-2.438C21.2,18.529,19.291,17.1,17.829,16,17.219,16.823,16.61,17.646,16,18.453Z",
    transform: "translate(5.333 2.285)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16662",
    "data-name": "Path 16662",
    d: "M22.7,6.438C22.1,5.63,21.486,4.808,20.876,4,19.368,5.128,17.463,6.56,16,7.657c.61.808,1.219,1.63,1.829,2.438C19.291,9,21.2,7.581,22.7,6.438Z",
    transform: "translate(5.333 -4)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16663",
    "data-name": "Path 16663",
    d: "M5.048,10.571A3.057,3.057,0,0,0,2,13.619v3.048a3.057,3.057,0,0,0,3.048,3.048H6.571v6.1H9.619v-6.1h1.524l7.619,4.571V6l-7.619,4.571Zm9.164.808,2.155-1.6V20.1l-3.458-1.954-.928-.652H5.048v-4.32h6.1l.838-.441Z",
    transform: "translate(-2 -2.952)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16664",
    "data-name": "Path 16664",
    d: "M16.286,13.755A6.827,6.827,0,0,0,14,8.65V18.844A6.769,6.769,0,0,0,16.286,13.755Z",
    transform: "translate(4.286 -1.564)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsNotifyMeWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-notifyMe-whiteIcon.92c7b3b5393da3c5e2753db3240f5371.svg";
export { ForwardRef as ReactComponent };